import { useCallback } from 'react';
import CustomModalComponent from '../../Controls/Modal/Modal';
import { AdvancedFilterProperties } from '../types';
import DateFilterModal from './DateFilterModal';
import ListFilterModal from './ListFilterModal';
import MainFilterModal from './MainFilterModal';
import './styles.scss';
import TimeFilterModal from './TimeFilterModal';

const ModalContentByType = ({
  onClose,
  property,
  onChangeModal,
}: {
  onClose: () => void;
  property: AdvancedFilterProperties | null;
  onChangeModal: (modalType: AdvancedFilterProperties | null) => void;
}) => {
  const handleOpenMainFilter = useCallback(() => {
    onChangeModal(null);
  }, [onChangeModal]);

  switch (property) {
    case null:
      return <MainFilterModal onClose={onClose} onChangeModal={onChangeModal} />;
    case AdvancedFilterProperties.OrderType:
    case AdvancedFilterProperties.OrderingChannel:
    case AdvancedFilterProperties.PaymentMethod:
    case AdvancedFilterProperties.Status:
    case AdvancedFilterProperties.Branch:
      return <ListFilterModal onClose={handleOpenMainFilter} property={property} />;
    case AdvancedFilterProperties.Date:
      return <DateFilterModal onClose={handleOpenMainFilter} />;
    case AdvancedFilterProperties.Time:
      return <TimeFilterModal onClose={handleOpenMainFilter} />;
    default:
      return null;
  }
};

interface FilterModalsProps {
  onCloseModal: () => void;
  currentProperty: AdvancedFilterProperties | null;
  onChangeModal: (currentProperty: AdvancedFilterProperties | null) => void;
  visible: boolean;
}

const FilterModals = ({ currentProperty, onCloseModal, onChangeModal, visible }: FilterModalsProps) => {
  const handleCloseRequest = useCallback(() => {
    if (currentProperty !== null) {
      onChangeModal(null);
    } else {
      onCloseModal();
    }
  }, [currentProperty, onChangeModal, onCloseModal]);

  return (
    <CustomModalComponent isOpen={visible} onRequestClose={handleCloseRequest} className="advanced-filter-modal-wrapper">
      <div className="advanced-filter-modal-bg">
        <ModalContentByType onClose={onCloseModal} onChangeModal={onChangeModal} property={currentProperty} />
      </div>
    </CustomModalComponent>
  );
};

export default FilterModals;
